import { Stack, Box } from "@mui/material";
import React from "react";
import AddIcon from "@mui/icons-material/Add";
import { Color, FontStyle } from "../../constants";

const AddSchoolButton = ({ setOpen }) => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      spacing={0.5}
      onClick={() => setOpen(true)}
      sx={{
        ...FontStyle.body,
        borderRadius: "8px",
        // border: "1px solid #000",
        height: "41px",
        width: "fit-content",
        backgroundColor: Color.primary,
        fontSize: "14px",
        px: "8px",
        cursor: "pointer",
        transition: "all 0.2s ease-in-out",
        ...(true && {
          //   fontWeight: "600",
          boxShadow: "0px 1px 5px rgba(0, 0, 0, 0.15)",
        }),
        "&:hover": {
          // backgroundColor: Color.primaryDark,
          transform: "scale(1.02)",
        },
      }}>
      <AddIcon sx={{ fontSize: "20px" }} />
      <Box>Add Another School/Degree</Box>
    </Stack>
  );
};

export default AddSchoolButton;
